<template>
    <page-option :disable-add="!checkAccess('key.create')" overflow-hidden>
        <template #title>
            <v-avatar color="#E3FCF7" size="35">
                <v-icon color="#108F6E" size>mdi-share-variant</v-icon>
            </v-avatar>
            <div class="pl-2 title-page"> Bản đồ chia sẻ</div>
        </template>
        <template #below-toolbar>
            <FilterSearch canShowInSearch v-model="params" :disableCreate="!checkAccess('key.create')"
                placeholder="Tìm kiếm theo tên" @click:create="onCreateItem()">
                <!-- <div class="d-flex flex-sm-row flex-column flex-warp">
                    <div class="filter-item">
                        <field-group v-model="params.status" background-color="#FFFFFF" dense :items="status.items"
                            :label="$t('active-title.title')" :loading="status.loading" no-label hide-details outlined
                            typeInput="v-select" clearable>
                        </field-group>
                    </div>
                    <div class="filter-item">
                        <field-group v-model="params.created_by_id" background-color="#FFFFFF" dense :items="user.items"
                            item-text="name" item-value="id" label="Người tạo" :loading="user.loading" no-label hide-details
                            outlined typeInput="v-select" clearable>
                        </field-group>
                    </div>
                    <div class="filter-item">
                        <field-group v-model="params.workspace_id" background-color="#FFFFFF" clearable dense
                            item-text="name" item-value="id" :items="workspace.items" :label="$t('sidebar.workspace.name')"
                            :loading="workspace.loading" no-label outlined hide-details typeInput="v-select">
                        </field-group>
                    </div>
                </div> -->
            </FilterSearch>
        </template>
        <v-sheet class="fillheight overflow-hidden">
            <base-serve-table ref="table" :api="api" :headers="headers" :params="params" :defaultParams="default_params">
                <template v-slot:[`item.active`]="{ value, item }">
                    <div>
                        <div @click.stop="toggleActiveMap(item)">
                            <v-switch color="primary" dense :false-value="false" disabled :input-value="value" small
                                :true-value="true"></v-switch>
                        </div>
                    </div>
                </template>
                <template v-slot:[`item.title_map_style`]="{ item }">
                    <div>
                        <div v-if="item.title_map_style && item.title_map_style.map_title">Tiêu đề: {{ item.title_map_style ? item.title_map_style.map_title : '' }}</div>
                        <div v-if="item.layer_title">Tiêu đề lớp: {{ item.layer_title }}</div>
                    </div>
                </template>
                <template v-slot:[`item.link`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="copyLink(item)">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </template>
                        <span>Sao chép liên kết</span>
                    </v-tooltip>
                    <a :href="getLinkShare(item)" target="_blank">
                        {{ getLinkShare(item) }}</a>
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                    <span>{{ item.updated_at | dateTime('short') }}</span>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ item.created_at | dateTime('short') }}</span>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <base-button-group class="full-width" :items="menus" :value="item"></base-button-group>
                </template>
            </base-serve-table>
        </v-sheet>
        <ShareDialog @reset="onReset" ref="dialog" />
    </page-option>
</template>
  
<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_MAPSHARE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import axios from '@service/auth-sdk';
import ShareDialog from './share-dialog.vue'
import { getCurrentUrl } from '@constant'

export default {
    mixins: [],
    components: {
        FilterSearch,
        ShareDialog
    },
    props: { option: { type: Object, default: () => ({ params: {} }) } },
    data: (vm) => ({
        workspace: {
            loading: false,
            items: [],
        },
        user: {
            loading: false,
            items: [],
        },
        status: {
            loading: false,
            items: [
                { text: 'Hoạt động', value: 2 },
                { text: 'Chờ phê duyệt', value: 1 },
                { text: 'Vô hiệu', value: 0 },
            ],
        },
        default_params: { with: 'created_by,workspaces' },
        params: { search: '', status: null, created_by_id: null },
        menus: [
            {
                type: 'update',
                handler: (item) => vm.onUpdateItem(item),
                disabled: (item) => !vm.checkAccess('key.update', item),
            },
            {
                type: 'delete',
                handler: (item) => vm.onDeleteItem(item),
                disabled: (item) => !vm.checkAccess('key.delete', item),
            },
        ],
        headers: [
            {
                text: 'Tên bản đồ',
                align: 'start',
                sortable: false,
                value: 'map_name',
            },
            {
                text: 'Tiêu đề',
                align: 'start',
                sortable: false,
                value: 'title_map_style',
            },
            // {
            //     text: 'Tiêu đề lớp bản đồ',
            //     align: 'start',
            //     sortable: true,
            //     value: 'layer_title',
            // },
            {
                text: 'Liên kết chia sẻ',
                align: 'start',
                value: 'link',
            },
            {
                text: 'Trạng thái',
                align: 'center',
                sortable: 'active',
                value: 'active',
                width: 120,
            },
            {
                trans: 'field.action',
                value: 'action',
                sortable: false,
                width: '150px',
                align: 'center',
            },
        ],
        loading: false,
    }),
    watch: {},
    computed: {
        ...mapGetters({
            currentId: 'auth/currentId',
            currentUser: 'auth/currentUser',
        }),
        api() {
            return API_MAPSHARE
        },
    },
    created() {

    },
    mounted() {
    },
    methods: {
        getLinkShare(item) {
            try {
                return getCurrentUrl() + `/tu-lieu-ban-do?key=${item.key}`
            } catch (error) {
                return null
            }
        },
        async onDeleteItem(item) {
            let confirm = new ConfirmBuilder()
            confirm
                .addMessage('Bạn có chắc chắn muốn xóa bản đồ này không')
                .setTitle('Xóa bản đồ')
                .setType('delete')
            if (await confirm.confirm()) {
                const result = await API_MAPSHARE.destroy(item.id, item)
                if (result.isDone) {
                    this.onReset()
                }
                return result
            }
        },
        copyLink(item) {
            var link = this.getLinkShare(item);
            navigator.clipboard.writeText(link)
        },
        onCreateItem() {
            this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
        },
        onUpdateItem(item) {
            this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
        },
        onReset() {
            this.$refs.table.reload()
        },
        async toggleActiveMap(item) {
            const { active, id } = item
            let confirm = new ConfirmBuilder()
            confirm
                .setTitle(active ? 'Vô hiệu liên kết chia sẻ' : 'Kích hoạt liên kết chia sẻ')
                .addMessage(active ? 'Các trang sử dụng liên kết này sẽ không thể hiển thị thông tin lớp bản đồ' : 'Các trang sử dụng liên kế này có thể xem các lớp bản đồ được chia sẻ')
            if (await confirm.confirm()) {
                const res = await API_MAPSHARE.getSdk().put(
                    `/change-active-map/${id}`
                )
                if (res && res.status == 200) item.active = !item.active
            }
        }
    },
}
</script>
  